import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { toastStyles } from '../styles/styles';
import { useTheme } from '../context/ThemeProvider';

const useGet = (queryKey, apiCall, defaultErrorMessage = 'Failed to fetch data', select, params) => {
    const { theme } = useTheme();

    const { data, error, isLoading, isError, isSuccess, refetch } = useQuery({
        queryKey: [queryKey],
        queryFn: apiCall,
        onError: (error) => {
            console.log('error', error);
            toast.error(error.message, { ...toastStyles, theme: theme });
        },
        select: select || ((data) => data.data.data)
    });

    return {
        data: data?.data,
        pagination: { totalCount: data?.totalCount, page: params?.page, limit: params?.limit },
        error,
        isLoading,
        isError,
        isSuccess,
        refetch
    };
};

export default useGet;
